import React from 'react';
import {findDOMNode} from 'react-dom'
import Popover from "../../gd-popover/popover-v2";
import PopoverPosition from "../../gd-popover/popover-position";
import {PopoverAttachmentType} from "../../gd-popover/@const";
import ReactionUsersList from "./user-list";
import {ALL_REACTIONS} from "../../../model2/reaction/const";
import Reaction from "../../../model2/reaction/reaction";
import EmojiSymbolDeprecated from "../../icons/common/emoji/emoji-symbol";

type Props = {
    className?      : string,

    size?           : number

    reactions       : Reaction[],
    reactionType    : number,

    onClick?        : callback
    disabled?       : boolean
}

type State = {
    showPopover : boolean
}

export default class ReactionView extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showPopover: false
        }
    }

    static defaultProps = {
        disabled        : false
    };

    onClick = (e:React.SyntheticEvent) => {

        if (this.props.disabled) return

        e.stopPropagation()
        this.props.onClick && this.props.onClick(this.props.reactionType)
    }

    onMouseEnter = () => {

        if (this.props.disabled) return

        const showPopover = true;
        this.setState({
            showPopover: showPopover
        });
    };

    onMouseLeave = () => {

        if (this.props.disabled) return

        const showPopover = false;
        this.setState({
            showPopover: showPopover
        });
    };

    render() {


        const emoji         = ALL_REACTIONS[this.props.reactionType]
        const myReaction    = !!_.find(this.props.reactions, (reaction) => reaction.userId === gd.user.id)

        const classes = Classes("reaction-view", this.props.className, {
            ['size-{0}'.f(this.props.size)] : this.props.size,
            "my-reaction"                   : myReaction,
            "show-popover"                  : this.state.showPopover,
            "disabled"                      : this.props.disabled
        });

        // const MenuComponent = this.props.menuComponent;
        // <ReactionUsersList hidePopover={this.onMouseLeave} menuParams={this.props.menuParams}/>

        return (
            <div className={classes} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClick}>

                <div className="reaction-emoji">
                    <EmojiSymbolDeprecated symbol={emoji} size="15" />
                </div>
                <div className="reaction-count">{this.props.reactions.length}</div>

                {this.state.showPopover && (
                    <Popover
                        popoverClass     = {Classes("gd-popup-menu")}
                        className        = ""
                        position         = {new PopoverPosition({
                            attachment      : "top center",
                            targetAttachment: "bottom center",
                            attachmentType  : PopoverAttachmentType.HORIZONTAL,
                            offset          : "0 0",
                        })}
                        getTargetFunc    = {() => findDOMNode(this)}
                    >
                        <ReactionUsersList reactions={this.props.reactions} />
                    </Popover>
                )}
            </div>
        )
    }
}

